import React from 'react';
import { graphql, createFragmentContainer } from 'react-relay';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
    addAndApplyFilter,
    clearFiltersByName,
    toggleFilterDisplay,
} from '../../../actions/filterActions';
import { injectIntl, intlShape, defineMessages } from 'react-intl';
import { SbSharedRefineMenuSearchInput } from '../SbSharedRefineMenuSearchInput/SbSharedRefineMenuSearchInput';
import styles from './SbSharedRefineMenuSearchWithin.scss';
import get from 'lodash.get';
import { FILTER_REFINE_SEARCH } from '../sbSharedRefineMenuConstants';
import { pageTypeConstants as pageTypes } from '../../../constants/pageTypeConstants';

const messages = defineMessages({
    placeholder: {
        id: 'sb.SbSharedRefineMenu.searchWithin.placeholder',
        defaultMessage: `Search within {totalResultsCount, plural, one {# result} other {# results}}`,
    },
});

export class SbSharedRefineMenuSearchWithinComponent extends React.Component {
    constructor(props) {
        super(props);

        const appliedSearchFilter = props.searchBrowse.appliedFilters.find(
            filter => filter.name === FILTER_REFINE_SEARCH
        );
        const inputValue = get(appliedSearchFilter, 'values.0.urlLabel') || '';

        this.state = {
            inputValue,
        };

        this.onInput = this.onInput.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    componentWillReceiveProps(newProps) {
        if (this.props.filtersShown && !newProps.filtersShown) {
            this.handleSearchSubmit();
        }
    }

    onInput(e) {
        this.setState({
            inputValue: e.target.value,
        });
    }

    onSubmit(e) {
        e.preventDefault();
        this.handleSearchSubmit();
    }

    handleSearchSubmit() {
        if (this.state.inputValue === '') {
            return;
        }
        // apply filters with new value
        this.props.updateFilters(this.state.inputValue);
        this.setState({ inputValue: '' });
        this.props.onSubmit();
    }

    render() {
        const { intl, searchBrowse } = this.props;
        const { totalResults: totalResultsCount, pageType } = searchBrowse;
        const { inputValue } = this.state;
        const placeholder = intl.formatMessage(messages.placeholder, {
            totalResultsCount,
        });
        return pageType !== pageTypes.SEARCH ? (
            <SbSharedRefineMenuSearchInput
                autoComplete="on"
                className={styles.container}
                placeholder={placeholder}
                value={inputValue}
                onInput={this.onInput}
                onSubmit={this.onSubmit}
            />
        ) : null;
    }
}

SbSharedRefineMenuSearchWithinComponent.propTypes = {
    intl: intlShape.isRequired,
    searchBrowse: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired,
    updateFilters: PropTypes.func.isRequired,
    filtersShown: PropTypes.bool.isRequired,
};

SbSharedRefineMenuSearchWithinComponent.defaultProps = {
    appliedSearchValue: '',
    onSubmit: () => {},
};

const mapStateToProps = ({ filters }) => ({
    filtersShown: filters.filtersShown,
});

function mapDispatchToProps(dispatch) {
    return {
        updateFilters(value) {
            dispatch(clearFiltersByName(FILTER_REFINE_SEARCH));
            dispatch(
                addAndApplyFilter(FILTER_REFINE_SEARCH, {
                    urlLabel: value,
                    displayName: value,
                })
            );
            dispatch(toggleFilterDisplay(false));
        },
    };
}

export const SbSharedRefineMenuSearchWithin = injectIntl(
    createFragmentContainer(
        connect(
            mapStateToProps,
            mapDispatchToProps
        )(SbSharedRefineMenuSearchWithinComponent),
        graphql`
            fragment SbSharedRefineMenuSearchWithin_searchBrowse on SearchBrowseQueryConnection {
                pageType
                totalResults
                appliedFilters {
                    name
                    values {
                        urlLabel
                    }
                }
            }
        `
    )
);
